// extracted by mini-css-extract-plugin
export default {"link-container":"link-container--0iufq","linkContainer":"link-container--0iufq","icon-row":"icon-row--Pnk4t","iconRow":"icon-row--Pnk4t"};